import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

// Defaults exist only so a component still renders if it is mounted outside an
// Inertia page. The real values come from BrandingService via shared props.
const FALLBACK = {
    appName: 'ISP Portal',
    appTitle: 'ISP Portal',
    appDescription: 'ISP Portal',
    productName: 'Omnifi',
    operatorName: '',
    supportEmail: null,
    supportPhone: null,
    primaryColor: '#2b7fff',
    logoUrl: null,
    logoDarkUrl: null,
    logoSmallUrl: null,
    faviconUrl: '/favicon.png',
    author: '',
    authorWebsite: '',
}

export function useBranding() {
    const page = usePage()
    return computed(() => ({ ...FALLBACK, ...(page.props.branding ?? {}) }))
}
